import flatpickr from 'flatpickr';
import { Mandarin } from 'flatpickr/dist/l10n/zh';

Mandarin.weekdays.shorthand = ['日', '一', '二', '三', '四', '五', '六'];

flatpickr.setDefaults({
  prevArrow: '<i class="twr twr-angle-left"></i>',
  nextArrow: '<i class="twr twr-angle-right"></i>',
  locale: Mandarin,
});

flatpickr.l10ns.default.firstDayOfWeek = 1;
flatpickr.l10ns.default.weekdays.shorthand = ['日', '一', '二', '三', '四', '五', '六'];

export default flatpickr;
